/**
 * Created by griga on 7/11/16.
 */


import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from './shared/layout/app-layouts/main-layout.component';
import { AuthLayoutComponent } from './shared/layout/app-layouts/auth-layout.component';
import { ModuleWithProviders } from '@angular/core';
import { UsersModule } from './+users/users.module';
import { AuthGuard } from './core/guards/auth.guard';
import { HomeResolver } from './core/guards/home.resolver';
import { AdminGuard } from './core/guards/admin.guard';
import { AdminPOSGuard } from './core/guards/admin-pos.guard';
import { AgentGuard } from './core/guards/agent.guard';
import { RfaGuard } from './core/guards/rfa.guard';
import { BillingGuard } from './core/guards/billing.guard';
import { BillingPlusAPosGuard } from './core/guards/billing-apos.guard';
import { BillingModifiedGuard } from './core/guards/billing_modified.guard';
import { RsSupervisorGuard } from './core/guards/rs-supervisor';

export const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "reservations/create",
        pathMatch: "full",
      },
      {
        path: "user",
        loadChildren: "app/+users/users.module#UsersModule",
        canActivate: [AdminGuard],
      },
      {
        path: "profile",
        loadChildren: "app/+profile/profile.module#ProfileModule",
      },
      {
        path: "calendar",
        loadChildren: "app/+calendar/calendar.module#CalendarModule",
        canActivate: [RsSupervisorGuard],
      },
      {
        path: "reservations",
        loadChildren:
          "app/+reservations/reservations.module#ReservationsModule",
        canActivate: [AgentGuard],
      },
      {
        path: "customers",
        loadChildren: "app/+customers/customers.module#CustomersModule",
        canActivate: [BillingGuard],
      },
      {
        path: "hotels",
        loadChildren: "app/+hotels/hotels.module#HotelsModule",
        canActivate: [RsSupervisorGuard],
      },
      {
        path: "cruises",
        loadChildren: "app/+cruises/cruises.module#CruisesModule",
        canActivate: [AdminGuard],
      },
      {
        path: "attractions",
        loadChildren: "app/+attractions/attractions.module#AttractionsModule",
        canActivate: [AdminGuard],
      },
      {
        path: "ports",
        loadChildren: "app/+ports/ports.module#PortsModule",
        canActivate: [AdminGuard],
      },
      {
        path: "promos",
        loadChildren: "app/+promos/promos.module#PromosModule",
        canActivate: [AdminGuard],
      },
      {
        path: "dailyCount",
        loadChildren: "app/+dailycount/daily-count.module#DailyCountModule",
        canActivate: [BillingGuard],
      },
      {
        path: "reports",
        loadChildren: "app/+reports/reports.module#ReportsModule",
        canActivate: [AgentGuard],
      },
      {
        path: "passes",
        loadChildren:
          "app/+donationfreepassreport/donationfreepass-report.module#DonationsFreepassReportModule",
        canActivate: [BillingGuard],
      },
      {
        path: "lunchReport",
        loadChildren: "app/+lunch-report/lunch-report.module#LunchReportModule",
        canActivate: [BillingGuard],
      },
      {
        path: "transportReport",
        loadChildren:
          "app/+transport-report/transport-report.module#TransportReportModule",
        canActivate: [BillingGuard],
      },
      {
        path: "billing",
        loadChildren: "app/+billing/billing.module#BillingModule",
        canActivate: [BillingGuard, BillingModifiedGuard],
      },
      {
        path: "waiver",
        loadChildren: "app/+waivers/waivers.module#WaiversModule",
        canActivate: [BillingGuard],
      },
      {
        path: "pos",
        loadChildren: "app/+pos/pos.module#POSModule",
        canActivate: [AdminPOSGuard],
      },
      {
        path: "posInvoices",
        loadChildren: "app/+pos/+reports/reports.module#ReportsPosModule",
        canActivate: [BillingPlusAPosGuard],
      },
      {
        path: "posInvoiceDetails",
        loadChildren:
          "app/+pos/+invoice-details-report/invoice-details.module#ReportsPosInvoiceDetailsModule",
        canActivate: [BillingPlusAPosGuard],
      },
      {
        path: "dsrReport",
        loadChildren: "app/+dsr-report/dsr-report.module#DsrReportModule",
        canActivate: [BillingPlusAPosGuard],
      },
      {
        path: "dsrCustomerReport",
        loadChildren:
          "app/+dsr-customer-report/dsr-customer-report.module#DsrCustomerReportModule",
        canActivate: [BillingPlusAPosGuard],
      },
    ],
    canActivate: [AuthGuard],
  },

  {
    path: "auth",
    component: AuthLayoutComponent,
    loadChildren: "app/+auth/auth.module#AuthModule",
  },
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// ./src/app/app.routing.ts